module.exports = __webpack_public_path__ + "static/pattern-design-05-2-5188254663baff108753fcb0f096e4e9.jpg";